import { render } from "./SdksTable.vue?vue&type=template&id=2b5c8c2b"
import script from "./SdksTable.vue?vue&type=script&lang=js"
export * from "./SdksTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__